/* eslint-disable no-useless-computed-key */
import React, { useState, useRef, useEffect } from "react"
import classNames from "classnames"
import { FieldArray, withFormik } from "formik"
import { mixed, object, string, array } from "yup"

import { v4 as uuidv4 } from "uuid"
import { Prompt, useHistory } from "react-router-dom"

import Input from "../../components/Input/Input"
import Grid from "@material-ui/core/Grid"
import Dropdown from "../../components/Dropdown/Dropdown"
import VideoCard from "../../components/Videos/VideoCard/VideoCard"
import ButtonComponent from "../../components/Button/Button"
import ConfirmCancelPopup from "../../components/Popup/ConfirmCancelPopup"
import { readFile } from "../../helpers/imageHelpers"
import { getVideoDuration, objectComparison } from "../../helpers"
import styles from "./EditStyles.module.scss"

import TextEditor from "../../components/TextEditor/TextEditor"
import { scrollOnError, types } from "./helpers"
import Loading from "../../components/Loading/Loading"
import DeleteIcon from "@material-ui/icons/Delete"
import useWindowHeightWidth from "../../hooks/useWindowHeightWidth"
import Button from "../../components/Button/Button"
import { messages } from "../../helpers/constants"
import CloseIcon from "@material-ui/icons/Close"
import MailIcon from "@material-ui/icons/Mail"
import { ReactComponent as AddMedia } from "../../images/icons/add_media.svg"
import userServices from "../../services"
import Peer from "../../components/CommunityTopic/Peer/Peer"
import Popup from "../../components/Popup/Popup"
import { isHaveBadWords } from "../../helpers/badWords"
import CommunityTopicCompanyAutocomplete from "../../components/CommunityTopicCompanyAutocomplete";
import InvitedCompaniesModal from "../../components/InvitedCompaniesModal/InvitedCompaniesModal";

const maxDescriptionLength = 146

const OpportunityShareForm = ({
  data,
  handleBlur,
  handleChange,
  setFieldValue,
  values,
  errors,
  touched,
  handleSubmit,
  onCancel,
  isSubmitting,
  onDelete,
  initialValues,
}) => {
  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const fileInputRef = useRef(null);
  const [buttonClickedStatus, setButtonClickedStatus] = useState(false);
  const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false);
  const [emailToDelete, setEmailToDelete] = useState(null);
  const [deletePopupMessage, setDeletePopupMessage] = useState("");
  const [emailToClearIndex, setEmailToClearIndex] = useState(null);
  const [companyInput, setCompanyInput] = useState("");
  const [addCompany, setAddCompany] = useState(true);

  const [deletePeer, setDeletePeer] = useState({
    remove: () => {},
    index: null,
  })
  const [showInvitedModal, setShowInvitedModal] = useState(false)
  const [alreadySentInvitesCount, setAlreadySentInvitesCount] = useState(0)

  const history = useHistory()

  useEffect(() => {
    if (data["uuid"]) {
      // Fetch the count of already sent invites
      userServices.opportunityServices
        .getInvitedCompanies(data["uuid"], 1)
        .then((response) => {
          if (response?.data?.total_count !== undefined) {
            setAlreadySentInvitesCount(response.data.total_count)
          }
        })
        .catch((error) => {
          console.error("Error fetching invited companies count:", error)
        })
    }
  }, [data["uuid"]])

  const deleteEmail = () => {
    if (emailToClearIndex !== null) {
      handleChange({
        target: {
          name: `emails.${emailToClearIndex}`,
          value: " ",
        },
      })
      setEmailToClearIndex(null)
      setIsOpenDeletePopup(false)
    }
    if (emailToDelete !== null) {
      setFieldValue(
        "peers",
        values["peers"].filter((peer, index) => index !== emailToDelete),
      )
      setFieldValue(
        "emails",
        values["emails"].filter((peer, index) => index !== emailToDelete),
      )
      setIsOpenDeletePopup(false)
      setEmailToDelete(null)
      setDeletePopupMessage("")
    }
    if (deletePeer.index !== null) {
      deletePeer.remove(deletePeer.index)
      setIsOpenDeletePopup(false)
      setDeletePeer({ ...deletePeer, index: null })
    }
  }

  const handleCancel = () => {
    setButtonClickedStatus(true)
    if (Object.keys(touched).length) {
      setIsPopupOpened(true)
    } else {
      history.goBack()
    }
  }

  return (
    <div className={styles.wrapper}>
      <Prompt
        when={!objectComparison(values, initialValues) && !buttonClickedStatus}
        message={messages.CONFIRM_LEAVING_FROM_PAGE}
      />
      {isSubmitting && (
        <div className={styles.loadingWrap}>
          <Loading />
        </div>
      )}
      {isPopupOpened && (
        <ConfirmCancelPopup
          setIsPopupOpened={setIsPopupOpened}
          handleCancel={() => {
            onCancel ? onCancel() : history.goBack()
            setIsPopupOpened(false)
          }}
        />
      )}
      {isOpenDeletePopup && (
        <Popup
          dialog
          subtitle={deletePopupMessage}
          button={
            <Button
              buttonStyle="black"
              onClick={() => {
                deleteEmail()
              }}
            >
              Yes
            </Button>
          }
          acceptButton={
            <Button
              buttonStyle="outlinedBlack"
              onClick={() => {
                setIsOpenDeletePopup(false)
                setEmailToClearIndex(null)
                setEmailToDelete(null)
                setDeletePeer({ ...deletePeer, index: null })
                setDeletePopupMessage("")
              }}
            >
              No
            </Button>
          }
          closeAction={() => {
            setIsOpenDeletePopup(false)
            setDeletePopupMessage("")
          }}
          isCrossIcon={true}
        />
      )}
      <div className={styles.headerWrapp}>
        <h4 className={styles.title}>
          Share Private Opportunity
        </h4>
        {data["uuid"] && (
          <div
            className={styles.viewInvitedLink}
            onClick={() => setShowInvitedModal(true)}
          >
            View Invited Companies/Professionals
          </div>
        )}
      </div>
      {showInvitedModal && (
        <InvitedCompaniesModal
          opportunityId={data["uuid"]}
          opportunityName={values["title"] || data["name"]}
          isOpen={showInvitedModal}
          onClose={() => setShowInvitedModal(false)}
        />
      )}
      <div className={styles.sectionWrapper}>
        <Grid
          className={styles.inputsWrapper}
          container
          component="div"
          spacing={3}
        >
          <Grid item component="div" xs={12}>
              <Input
                  className={styles.input}
                  name="opportunity_type"
                  label="Opportunity Type*"
                  fieldStyle={"black"}
                  disabled={true}
                  value={values["opportunity_type"]}
              />
          </Grid>
          <Grid item component="div" xs={12}>
            <Input
              className={styles.input}
              name="opportunity_name"
              label="Opportunity Name*"
              fieldStyle={"black"}
              disabled={true}
              value={values["title"]}
            />
          </Grid>
            <Grid item component="div" xs={12}>
            <div className={styles.inviteCounter}>
              {Math.max(0, 200 - (alreadySentInvitesCount + values.companies.length + values.emails.filter(e => e && e.trim() && e.trim() !== " ").length + values.peers.length))}/200 invites remaining
            </div>
          </Grid>
          <Grid item component="div" xs={12} md={6}>
            <Dropdown
              id="opportunity_availability_duration"
              className={styles.dropdown}
              name="opportunity_availability_duration"
              label="How long is this opportunity available?*"
              fieldStyle={"black"}
              options={[
                { id: "30", value: "30 Days" },
                { id: "60", value: "60 Days" },
                { id: "90", value: "90 Days" },
                { id: "120", value: "120 Days" },
                { id: "150", value: "150 Days" },
                { id: "180", value: "180 Days" },
                { id: "210", value: "210 Days" },
                { id: "240", value: "240 Days" },
                { id: "270", value: "270 Days" },
                { id: "300", value: "300 Days" },
                { id: "330", value: "330 Days" },
                { id: "360", value: "360 Days" },
                { id: "365+", value: "365+ Days" },
              ]}
              value={
                values["opportunity_availability_duration"]
                  ? (() => {
                      const option = [
                        { id: "30", value: "30 Days" },
                        { id: "60", value: "60 Days" },
                        { id: "90", value: "90 Days" },
                        { id: "120", value: "120 Days" },
                        { id: "150", value: "150 Days" },
                        { id: "180", value: "180 Days" },
                        { id: "210", value: "210 Days" },
                        { id: "240", value: "240 Days" },
                        { id: "270", value: "270 Days" },
                        { id: "300", value: "300 Days" },
                        { id: "330", value: "330 Days" },
                        { id: "360", value: "360 Days" },
                        { id: "365+", value: "365+ Days" },
                      ].find((opt) => opt.id === values["opportunity_availability_duration"])
                      return option || { id: "30", value: "30 Days" }
                    })()
                  : { id: "30", value: "30 Days" }
              }
              onChange={(name, option) => {
                setFieldValue("opportunity_availability_duration", option.id)
              }}
              onBlur={() => handleBlur({ target: { name: "opportunity_availability_duration" } })}
              error={errors["opportunity_availability_duration"] && touched["opportunity_availability_duration"]}
              errorMessage={errors["opportunity_availability_duration"]}
            />
          </Grid>
          <Grid item component="div" xs={12} md={6}>
            <Dropdown
              id="company_receive_alert"
              className={styles.dropdown}
              name="company_receive_alert"
              label="Should company view all private opportunities? *"
              fieldStyle={"black"}
              options={[
                { id: "yes", value: "Yes" },
                { id: "no", value: "No" },
              ]}
              value={
                values["company_receive_alert"]
                  ? {
                      id: values["company_receive_alert"],
                      value: values["company_receive_alert"] === "yes" ? "Yes" : "No",
                    }
                  : { id: "no", value: "No" }
              }
              onChange={(name, option) => {
                setFieldValue("company_receive_alert", option.id)
              }}
              onBlur={() => handleBlur({ target: { name: "company_receive_alert" } })}
              error={errors["company_receive_alert"] && touched["company_receive_alert"]}
              errorMessage={errors["company_receive_alert"]}
            />
            </Grid>

          {values["peers"].length > 0 && (
            <Grid item xs={12} className={styles.peerWrapper}>
              {values["peers"] &&
                values["peers"].map((peer, index) => (
                  <Peer
                    key={peer.uuid}
                    avatar={peer.photo}
                    name={peer.name}
                    uuid={peer.uuid}
                    email={peer.email}
                    onCrossClick={({ name }) => {
                      setDeletePopupMessage(
                        `Are you sure you want to remove user\n${name}?`,
                      )
                      setIsOpenDeletePopup(true)
                      setEmailToDelete(index)
                    }}
                  />
                ))}
            </Grid>
          )}

          <Grid item xs={12}>
            <div className={styles.inviteContainer}>
              <Grid container spacing={4}>
                <Grid xs={12} md={5} item>
                <FieldArray
                    name="companies"
                    render={({remove, push}) => (
                        <div className={styles.inviteSection}>
                            {values.companies.length > 0 &&
                                values.companies.map((company, index) => {
                                    return (
                                        <div className={styles.inviteInputs} key={index}>
                                            <div className={styles.inviteWrapper}>
                                                <Input
                                                    type={"text"}
                                                    className={styles.input}
                                                    name={`companies.${index}`}
                                                    placeholder="Enter Company"
                                                    value={company.name}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div
                                                onClick={() => remove(index)}
                                                className={classNames("iconWrap", styles.removeInvite)}
                                            >
                                                <CloseIcon
                                                    className={styles.removeInviteIcon}
                                                    style={{color: "rgba(255, 255, 255, 0.7)"}}
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                        </div>
                    )}
                />
                <div className={styles.inviteSection}>
                    { addCompany && (
                        <div className={styles.inviteInputs}>
                        <div className={styles.inviteWrapper}>
                            <CommunityTopicCompanyAutocomplete
                                fieldName="companies"
                                companyInput={companyInput || ""}
                                externalDispatch={(setter) => {
                                    setCompanyInput(setter)
                                    if (setter.id && setter.name) {
                                        setFieldValue("companies", [...values["companies"], setter])
                                        setAddCompany(false)
                                        setCompanyInput("")
                                    }
                                }}
                                    onClear={() => {
                                setCompanyInput("")
                            }}
                            />
                        </div>
                    </div>
                        )}
                    <div
                        onClick={() => {
                            setAddCompany(true)
                            setCompanyInput("")
                        }}
                        className={classNames("goldLink", styles.addNewLink)}
                    >
                        + Add new company
                    </div>
                </div>
                </Grid>
                
                <Grid xs={12} md={2} item className={styles.orSeparator}>
                  <div className={styles.orText}>or</div>
                </Grid>

                <Grid xs={12} md={5} item>
                <FieldArray
                    name="emails"
                    render={({remove, push}) => (
                        <div className={styles.inviteSection}>
                            {values.emails.length > 0 &&
                                values.emails.map((email, index) => {
                                    let firstIndex = values["emails"].indexOf(
                                        values["emails"][index],
                                    )
                                    if (
                                        values["emails"].filter(
                                            (email) => email === values["emails"][index],
                                        ).length >= 1 &&
                                        index === firstIndex &&
                                        values["peers"]
                                            .map((peer) => peer.email)
                                            .includes(values["emails"][index])
                                    ) {
                                        return null
                                    }

                                    let isFirstInput =
                                        Math.abs(values["peers"].length - index) === 0
                                    if (index < 200)
                                        return (
                                            <div className={styles.inviteInputs} key={index}>
                                                <div className={styles.inviteWrapper}>
                                                    <Input
                                                        afterIcon={
                                                            <MailIcon
                                                                style={{
                                                                    color: "rgba(255, 255, 255, 0.7)",
                                                                }}
                                                            />
                                                        }
                                                        type={"text"}
                                                        className={styles.input}
                                                        name={`emails.${index}`}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Enter email"
                                                        value={email.trim() || ""}
                                                        error={
                                                            errors.emails &&
                                                            errors.emails[index] &&
                                                            errors.emails[index] &&
                                                            touched.emails &&
                                                            touched.emails[index] &&
                                                            errors.emails[index]
                                                        }
                                                        errorMessage={
                                                            errors.emails &&
                                                            errors.emails[index] &&
                                                            errors.emails[index] &&
                                                            touched.emails &&
                                                            touched.emails[index] &&
                                                            errors.emails[index]
                                                        }
                                                    />
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (isFirstInput) {
                                                            if (values["emails"][index] === " ") {
                                                            } else {
                                                                setDeletePopupMessage(
                                                                    `Are you sure you want to delete this email?\nCurrent data will be lost.`,
                                                                )
                                                                setIsOpenDeletePopup(true)
                                                                setEmailToClearIndex(index)
                                                            }
                                                        } else if (
                                                            values["emails"][index] === " "
                                                        ) {
                                                            remove(index)
                                                        } else {
                                                            setDeletePeer({
                                                                remove: remove,
                                                                index: index,
                                                            })
                                                            setIsOpenDeletePopup(true)
                                                            setEmailToDelete(values["emails"][index])
                                                            setDeletePopupMessage(
                                                                `Are you sure you want to delete this email?\nCurrent data will be lost.`,
                                                            )
                                                        }
                                                    }}
                                                    className={classNames(
                                                        "iconWrap",
                                                        styles.removeInvite,
                                                    )}
                                                >
                                                    <CloseIcon
                                                        className={styles.removeInviteIcon}
                                                        style={{
                                                            color: "rgba(255, 255, 255, 0.7)",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                })}
                            {values.emails.length < 200 && (
                                <div
                                    className={classNames("goldLink", styles.addNewLink)}
                                    onClick={() => push(" ")}
                                >
                                    + Add new email
                                </div>
                            )}
                        </div>
                    )}
                />
            </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid
          component="div"
          container
          justify="flex-end"
          className={styles.buttonsWrapper}
        >
          <div className={styles.btnsWrap}>
            <Button
              className={styles.btn}
              buttonStyle="outlined"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleSubmit()
                scrollOnError()
                setButtonClickedStatus(true)
              }}
              buttonStyle="contained"
              disabled={isSubmitting}
              className={styles.btn}
            >
              Invite
            </Button>
          </div>
        </Grid>
      </div>
    </div>
  )
}

const FormikApp = withFormik({
  enableReinitialize: true,
  mapPropsToValues({ data }) {
    let emptyStory =
      '{"blocks":[{"key":"fvm5o","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}'
    return {
      ["opportunity_type"]: data["opportunity_type"] || "",
      ["title"]: data["name"] || "",
      ["emails"]: data["peers"]?.map((peer) => peer.email).concat(" ") || [" "],
      ["companies"]: data["companies"] || [],
      ["peers"]: data["peers"] || [],
      ["opportunity_availability_duration"]: data["opportunity_availability_duration"] || "30",
      ["company_receive_alert"]: data["company_receive_alert"] || "no",
    }
  },
  validationSchema: () =>
    object().shape(
      {
        ["opportunity_availability_duration"]: string().required("This field is required"),
        ["company_receive_alert"]: string().required("This field is required"),
        ["emails"]: array().of(
          string()
            .test(
              "email-format",
              "Please enter a valid email address",
              (value) => {
                if (value === " " || value === "" || !value || !value.trim()) {
                  return true
                }

                const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                return emailRegex.test(String(value).toLowerCase())
              },
            )
            .test(
              "duplicate-email",
              "This email address is already entered. Please try another one.",
              function (value) {
                if (value === " " || value === "" || !value || !value.trim()) {
                  return true
                }

                // Extract index from path (handles both "emails[0]" and "emails.0" formats)
                const match = this.path.match(/\[(\d+)\]|\.(\d+)$/)
                const index = match ? Number(match[1] || match[2]) : Number(this.path[7] || 0)

                if (this.parent.indexOf(value) === index) {
                  return true
                }
                return (
                  this.parent.indexOf(value) ===
                  this.parent.lastIndexOf(value)
                )
              },
            )
            .test(
              "email-exists",
              "User not available in our platform",
              async function (value) {
                if (value === " " || value === "" || !value || !value.trim()) {
                  return true
                }
                const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                if (emailRegex.test(String(value).toLowerCase())) {
                  try {
                    let {
                      data,
                    } = await userServices.suggestionServices.checkEmailInBase(
                      value,
                    )
                    if (data?.my_email === true) {
                      return this.createError({
                        message:
                          "This is your email address. You are allowed to invite only other users",
                        path: this.path,
                      })
                    }
                    return data.found !== "false"
                  } catch (error) {
                    return false
                  }
                }
                return true
              },
            ),
        ).when("question_type", {
          is: (question_type) => question_type === "peer_circles",
          then: array().of(
            string()
              .test(
                "email-format",
                "Please enter a valid email address",
                (value) => {
                  if (value === " " || value === "" || !value || !value.trim()) {
                    return true
                  }

                  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                  return emailRegex.test(String(value).toLowerCase())
                },
              )
              .test(
                "regex",
                "Please enter your email address in format yourname@example.com",
                (value) => {
                  if (value === " " || value === "" || !value) {
                    return true
                  }

                  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

                  return emailRegex.test(String(value).toLowerCase())
                },
              )
              .test(
                "length",
                "Please enter a valid email address that consists of no more than 200 characters",
                (value) => {
                  if (value === " " || value === "" || !value) return true
                  return value.length < 200
                },
              )
              .test(
                "dateToCheck",
                "This email address is already entered. Please try another one.",
                function (value) {
                  if (value === " " || value === "" || !value) {
                    return true
                  }

                  let index = Number(this.path[7])

                  if (this.parent.indexOf(value) === index) {
                    return true
                  }
                  return (
                    this.parent.indexOf(value) ===
                    this.parent.lastIndexOf(value)
                  )
                },
              )
              .test(
                "belong",
                "This email address does not belong to any registered user.",
                async function (value) {
                  if (value === " " || value === "" || !value) return true
                  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  if (emailRegex.test(String(value).toLowerCase())) {
                    let {
                      data,
                    } = await userServices.suggestionServices.checkEmailInBase(
                      value,
                    )
                    if (data?.my_email === true) {
                      return this.createError({
                        message:
                          "This is your email address. You are allowed to invite only other users",
                        path: this.path,
                      })
                    }
                    return data.found !== "false"
                  }
                },
              ),
          ),
        }),
      },
    ),
  handleSubmit(values, { setSubmitting, props: { onSave } }) {
    setSubmitting(true)
    let savedValues = {
      ...values,
      emails: values["emails"].filter((email) => email.trim()),
      companies: values["companies"].map((company) => company.id),
      opportunity_availability_duration: values["opportunity_availability_duration"],
      company_receive_alert: values["company_receive_alert"],
    }
    delete savedValues["peers"]

    onSave(savedValues)
  },
})(OpportunityShareForm)

export default FormikApp
